import BaseComponent from "../BaseComponent";
import ToggleInput from "components/Properties/InputComponents/ToggleInput";
import {NumberInput, NumberSliderInput} from "components/Properties/InputComponents/NumberInput";

const CameraComponent = ({selectedObject, checkboxOnChange, inputOnChange}) => {
  const {isPerspectiveCamera, isOrthographicCamera} = selectedObject;
  const {enabled, depth, renderTarget, viewport} = selectedObject.userData;
  if (selectedObject.type.includes("Camera")) {
    return (
      <BaseComponent title="Camera" foldable={true}>
        <ToggleInput name="CameraEnabled" checked={enabled} checkboxOnChange={checkboxOnChange} />
        <NumberInput name="CameraDepth" value={depth} inputOnChange={inputOnChange} />
        {isPerspectiveCamera && (
          <>
            <NumberSliderInput name="CameraFov" value={selectedObject.fov} inputOnChange={inputOnChange} min={0} max={180} />
            <NumberSliderInput name="CameraNear" value={selectedObject.near} inputOnChange={inputOnChange} min={0.1} max={1000} />
            <NumberSliderInput name="CameraFar" value={selectedObject.far} inputOnChange={inputOnChange} min={0} max={1000} />
          </>
        )}
        {isOrthographicCamera && (
          <>
            <NumberSliderInput name="CameraLeft" value={selectedObject.left} inputOnChange={inputOnChange} min={-100} max={0} />
            <NumberSliderInput name="CameraRight" value={selectedObject.right} inputOnChange={inputOnChange} min={0} max={100} />
            <NumberSliderInput name="CameraTop" value={selectedObject.top} inputOnChange={inputOnChange} min={0} max={100} />
            <NumberSliderInput name="CameraBottom" value={selectedObject.bottom} inputOnChange={inputOnChange} min={-100} max={0} />
            <NumberSliderInput name="CameraNear" value={selectedObject.near} inputOnChange={inputOnChange} min={0} max={1000} />
            <NumberSliderInput name="CameraFar" value={selectedObject.far} inputOnChange={inputOnChange} min={0} max={1000} />
          </>
        )}
        {/* [TODO] RenderTarget */}
        {/* [TODO] perspectiveCamera aspect if renderTarget is set */}
        {/* [TODO] Viewport */}
      </BaseComponent>
    );
  } else {
    return null;
  }
};

export default CameraComponent;
